import { Component, ElementRef, forwardRef, HostBinding, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { AccountConfigService } from '../../../../services/account-config/account-config.service';
import { FormationService } from '../../../../services/formation/formation.service';

@Component({
  selector: 'ags-formation-info',
  templateUrl: './formation-info.component.html',
  styleUrls: ['./formation-info.component.scss']
})
export class FormationInfoComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @ViewChild('formation') formation: ElementRef<HTMLElement>;
  @Input('idFormation')
  set _idFormation(value: number) {
    this.idFormation = value;
  }
  public idFormation: number;
  public formationInfo: any;
  constructor(
    private formationService: FormationService,
    @Inject(forwardRef(() => AccountConfigService)) private accountConfigService: AccountConfigService
  ) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    if (this.idFormation) {
      this.formationService.getFormationInfo(this.idFormation).subscribe(res => (this.formationInfo = res));
    }
  }
}
